import { render, staticRenderFns } from "./AppNamePlace.vue?vue&type=template&id=624f185e&"
import script from "./AppNamePlace.vue?vue&type=script&lang=js&"
export * from "./AppNamePlace.vue?vue&type=script&lang=js&"
import style0 from "./AppNamePlace.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports